import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const createSchemeDetail = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/schemedetail`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const fetchSchemeDetailsBySchemeId = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/schemedetail/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    });
};

export const fetchAllSchemesWithDetails = (params) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/schemedetail/schemes`, {
      headers: authHeader(),
      params,
    })
    .then((res) => {
      return res.data.data;
    });
};

export const updateSchemeDetail = (id, data) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`${process.env.REACT_APP_BASE_URL}/schemedetail/${id}`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const deleteSchemeDetail = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${process.env.REACT_APP_BASE_URL}/schemedetail/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};
